"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankConnectionUpdateStatusEnum = void 0;
var BankConnectionUpdateStatusEnum;
(function (BankConnectionUpdateStatusEnum) {
    BankConnectionUpdateStatusEnum["DOWNLOADING"] = "DOWNLOADING";
    BankConnectionUpdateStatusEnum["DONE"] = "DONE";
    BankConnectionUpdateStatusEnum["FAILED"] = "FAILED";
})(BankConnectionUpdateStatusEnum || (exports.BankConnectionUpdateStatusEnum = BankConnectionUpdateStatusEnum = {}));
